export interface Story {
  id: string
  title: string
  content: string
  excerpt: string
  language: string
  brand: string
  category: string
  date: string
  author: string
}
export const mockStories: Story[] = [
  {
    id: '1',
    title: 'Breaking: Major Climate Summit Reaches Historic Agreement',
    content:
      'World leaders have reached a groundbreaking agreement on climate action at the Global Climate Summit. The accord includes commitments to reduce carbon emissions by 50% by 2030 and establish a $100 billion fund for developing nations...',
    excerpt:
      'World leaders reach groundbreaking climate agreement with ambitious emission reduction targets.',
    language: 'English',
    brand: 'Global News Network',
    category: 'Environment',
    date: '2024-01-15',
    author: 'Jane Smith',
  },
  {
    id: '2',
    title: 'Tech Giant Announces Revolutionary AI Breakthrough',
    content:
      'In a surprise announcement, TechCorp unveiled its latest artificial intelligence system that promises to revolutionize healthcare diagnostics. The AI can detect diseases with 99% accuracy...',
    excerpt:
      'New AI system achieves unprecedented accuracy in medical diagnostics.',
    language: 'English',
    brand: 'Tech Today',
    category: 'Technology',
    date: '2024-01-14',
    author: 'John Doe',
  },
  {
    id: '3',
    title: 'Olympic Games: Underdog Team Wins Gold in Dramatic Final',
    content:
      'In one of the most thrilling Olympic finals ever witnessed, the underdog team from a small nation clinched gold in a nail-biting finish. The crowd erupted as the final whistle blew...',
    excerpt:
      'Underdog team creates Olympic history with stunning gold medal victory.',
    language: 'English',
    brand: 'Sports Daily',
    category: 'Sports',
    date: '2024-01-13',
    author: 'Mike Johnson',
  },
  {
    id: '4',
    title: 'Economic Recovery: Markets Hit Record Highs',
    content:
      'Global stock markets reached record highs today as economic indicators point to a strong recovery. Analysts attribute the surge to improved consumer confidence and robust corporate earnings...',
    excerpt: 'Stock markets soar to new records amid economic optimism.',
    language: 'English',
    brand: 'Financial Times',
    category: 'Business',
    date: '2024-01-12',
    author: 'Sarah Williams',
  },
  {
    id: '5',
    title: 'Archaeological Discovery Rewrites Ancient History',
    content:
      'Archaeologists have uncovered a previously unknown civilization dating back 5,000 years. The discovery includes intricate artifacts and written records that challenge our understanding of ancient cultures...',
    excerpt:
      'Ancient civilization discovery challenges historical understanding.',
    language: 'English',
    brand: 'Science Weekly',
    category: 'Science',
    date: '2024-01-11',
    author: 'Dr. Emily Chen',
  },
  {
    id: 'ap-1',
    title: 'New Accessibility Standards Proposed for Public Buildings',
    content:
      'Federal officials have announced proposed updates to accessibility standards for public buildings, incorporating feedback from disability advocates and building professionals...',
    excerpt:
      'Proposed standards aim to improve accessibility in public spaces.',
    language: 'English',
    brand: 'Access Press',
    category: 'General News',
    date: '2024-01-16',
    author: 'Access Press Staff',
  },
  {
    id: 'ap-2',
    title: 'Community Programs Expand Services for Disabled Veterans',
    content:
      'Local organizations have expanded their support programs for disabled veterans, offering enhanced accessibility services and community resources...',
    excerpt: 'Enhanced support programs launched for disabled veterans.',
    language: 'English',
    brand: 'Access Press',
    category: 'General News',
    date: '2024-01-15',
    author: 'Access Press Staff',
  },
  {
    id: 'bn-1',
    title: 'Borough Council Approves New Community Center Plans',
    content:
      'The Bernardsville Borough Council has unanimously approved plans for a new community center, which will include recreational facilities and meeting spaces for local organizations...',
    excerpt: 'New community center project gets green light from council.',
    language: 'English',
    brand: 'Bernardsville News',
    category: 'General News',
    date: '2024-01-16',
    author: 'Bernardsville News Staff',
  },
  {
    id: 'bn-2',
    title: 'Local School District Celebrates Academic Excellence Awards',
    content:
      'Bernardsville schools honored outstanding students and teachers at the annual Academic Excellence Awards ceremony, recognizing achievements in academics, arts, and athletics...',
    excerpt: 'Schools celebrate student and teacher achievements.',
    language: 'English',
    brand: 'Bernardsville News',
    category: 'General News',
    date: '2024-01-15',
    author: 'Bernardsville News Staff',
  },
  {
    id: 'cl-1',
    title: 'Analysis: NYC Housing Crisis Demands Comprehensive Solutions',
    content:
      'As housing affordability reaches critical levels in New York City, policy experts and advocates are calling for comprehensive approaches that address both supply and affordability challenges...',
    excerpt:
      'Experts examine multi-faceted approaches to housing affordability.',
    language: 'English',
    brand: 'City Limits',
    category: 'Politics',
    date: '2024-01-16',
    author: 'City Limits Staff',
  },
  {
    id: 'cl-2',
    title: 'Community Land Trusts Gain Momentum in Brooklyn',
    content:
      'Brooklyn neighborhoods are increasingly turning to community land trusts as a model for preserving affordable housing and preventing displacement...',
    excerpt:
      'Community-led housing models show promise in preserving affordability.',
    language: 'English',
    brand: 'City Limits',
    category: 'Politics',
    date: '2024-01-15',
    author: 'City Limits Staff',
  },
  {
    id: 'cvl-1',
    title: 'City Council Debates Transportation Infrastructure Plan',
    content:
      'Lexington city council members engaged in extensive debate over a proposed $50 million transportation infrastructure plan aimed at improving public transit and road safety...',
    excerpt: 'Major infrastructure investment under council consideration.',
    language: 'English',
    brand: 'CivicLex',
    category: 'Politics',
    date: '2024-01-16',
    author: 'CivicLex Staff',
  },
  {
    id: 'cvl-2',
    title: 'Community Forums Address Downtown Revitalization Efforts',
    content:
      'Local residents and business owners gathered for community forums to discuss downtown revitalization strategies, including plans for new mixed-use developments and public spaces...',
    excerpt: 'Residents weigh in on downtown development plans.',
    language: 'English',
    brand: 'CivicLex',
    category: 'Politics',
    date: '2024-01-15',
    author: 'CivicLex Staff',
  },
  {
    id: 'cm-1',
    title: 'University Research Team Makes Breakthrough in Renewable Energy',
    content:
      'Researchers at the University of Missouri have announced a significant breakthrough in solar cell efficiency, potentially revolutionizing renewable energy technology...',
    excerpt: 'MU researchers advance solar energy technology.',
    language: 'English',
    brand: 'Columbia Missourian',
    category: 'General News',
    date: '2024-01-16',
    author: 'Columbia Missourian Staff',
  },
  {
    id: 'cm-2',
    title: 'Local Business District Sees Record Growth in Small Startups',
    content:
      'Columbia business district has experienced a surge in new small business openings, with entrepreneurs citing supportive local policies and community engagement as key factors...',
    excerpt: 'Small business boom transforms downtown Columbia.',
    language: 'English',
    brand: 'Columbia Missourian',
    category: 'General News',
    date: '2024-01-15',
    author: 'Columbia Missourian Staff',
  },
  {
    id: 'cb-1',
    title: 'State Legislature Debates Comprehensive Climate Bill',
    content:
      'Massachusetts lawmakers are engaged in heated debate over a comprehensive climate change bill that would set ambitious emissions reduction targets and invest billions in clean energy infrastructure...',
    excerpt: 'Major climate legislation sparks debate at State House.',
    language: 'English',
    brand: 'CommonWealth Beacon',
    category: 'Politics',
    date: '2024-01-16',
    author: 'CommonWealth Beacon Staff',
  },
  {
    id: 'cb-2',
    title: 'Education Reform Package Advances Through Committee',
    content:
      'A comprehensive education reform package has advanced through the Joint Committee on Education, proposing increased funding for public schools and expanded early childhood education programs...',
    excerpt: 'Education funding reforms move forward in legislature.',
    language: 'English',
    brand: 'CommonWealth Beacon',
    category: 'Politics',
    date: '2024-01-15',
    author: 'CommonWealth Beacon Staff',
  },
  {
    id: 'ca-1',
    title: 'Programa Comunitario Ofrece Recursos de Salud Gratuitos',
    content:
      'Una nueva iniciativa comunitaria en Phoenix está ofreciendo servicios de salud gratuitos y recursos educativos para familias de habla hispana, incluyendo exámenes médicos y asesoramiento nutricional...',
    excerpt: 'Servicios de salud gratuitos disponibles para la comunidad.',
    language: 'Spanish',
    brand: 'Conecta Arizona',
    category: 'General News',
    date: '2024-01-16',
    author: 'Conecta Arizona Staff',
  },
  {
    id: 'ca-2',
    title: 'Escuelas Locales Celebran Éxito en Programas Bilingües',
    content:
      'Los distritos escolares de Arizona están celebrando el éxito de sus programas de educación bilingüe, con estudiantes mostrando mejoras significativas en rendimiento académico y competencia lingüística...',
    excerpt: 'Programas bilingües muestran resultados positivos.',
    language: 'Spanish',
    brand: 'Conecta Arizona',
    category: 'General News',
    date: '2024-01-15',
    author: 'Conecta Arizona Staff',
  },
  {
    id: 'dcw-1',
    title: 'Criminal Justice Reform Initiatives Show Early Promise',
    content:
      'New criminal justice reform programs in Washington, D.C. are showing early signs of success, with reduced recidivism rates and improved community outcomes according to preliminary data...',
    excerpt: 'Reform programs demonstrate positive early results.',
    language: 'English',
    brand: 'D.C. Witness',
    category: 'Politics',
    date: '2024-01-16',
    author: 'D.C. Witness Staff',
  },
  {
    id: 'dcw-2',
    title: 'Community Court Program Expands to Additional Neighborhoods',
    content:
      'The successful community court program is expanding to three additional D.C. neighborhoods, offering alternatives to traditional prosecution for non-violent offenses...',
    excerpt: 'Alternative justice program grows across the district.',
    language: 'English',
    brand: 'D.C. Witness',
    category: 'Politics',
    date: '2024-01-15',
    author: 'D.C. Witness Staff',
  },
  {
    id: 'dny-1',
    title: 'New Immigration Policy Changes Impact NYC Communities',
    content:
      'Recent changes to immigration policies are having significant impacts on New York City immigrant communities, with local organizations working to provide support and resources...',
    excerpt: 'Policy changes affect immigrant community services.',
    language: 'English',
    brand: 'Documented NY',
    category: 'General News',
    date: '2024-01-16',
    author: 'Documented NY Staff',
  },
  {
    id: 'dny-2',
    title: 'Community Organizations Launch Legal Aid Initiative',
    content:
      'A coalition of New York immigrant advocacy groups has launched a new legal aid initiative providing free immigration legal services to underserved communities across the five boroughs...',
    excerpt: 'Free legal services expand for immigrant communities.',
    language: 'English',
    brand: 'Documented NY',
    category: 'General News',
    date: '2024-01-15',
    author: 'Documented NY Staff',
  },
  {
    id: 'epm-1',
    title: 'Border Community Leaders Discuss Economic Development',
    content:
      'El Paso community leaders gathered to discuss new economic development initiatives aimed at strengthening the border region economy and creating opportunities for local residents...',
    excerpt: 'Leaders plan economic growth strategies for border region.',
    language: 'English',
    brand: 'El Paso Matters',
    category: 'General News',
    date: '2024-01-16',
    author: 'El Paso Matters Staff',
  },
  {
    id: 'epm-2',
    title: 'Water Conservation Efforts Show Positive Results',
    content:
      'El Paso water conservation programs have achieved significant success, with residents reducing water consumption by 15% through innovative conservation strategies and community engagement...',
    excerpt: 'Community conservation efforts yield measurable results.',
    language: 'English',
    brand: 'El Paso Matters',
    category: 'General News',
    date: '2024-01-15',
    author: 'El Paso Matters Staff',
  },
  {
    id: 'egn-1',
    title: 'Historic Main Street Renovation Project Nears Completion',
    content:
      'The multi-year Main Street renovation project is approaching completion, with new sidewalks, lighting, and landscaping transforming the historic downtown area while preserving its character...',
    excerpt: 'Downtown revitalization project reaches final phase.',
    language: 'English',
    brand: 'East Greenwich News',
    category: 'General News',
    date: '2024-01-16',
    author: 'East Greenwich News Staff',
  },
  {
    id: 'egn-2',
    title: 'Local Library Expands Digital Resources and Programs',
    content:
      'The East Greenwich Free Library has launched an expanded collection of digital resources and new community programs, including technology training classes and virtual author events...',
    excerpt: 'Library enhances digital offerings for community.',
    language: 'English',
    brand: 'East Greenwich News',
    category: 'General News',
    date: '2024-01-15',
    author: 'East Greenwich News Staff',
  },
  {
    id: 'et-1',
    title: 'Comunidad de la Misión Celebra Festival Cultural Anual',
    content:
      'La comunidad del Distrito de la Misión se reunió para celebrar su festival cultural anual, destacando la rica herencia latina de San Francisco y promoviendo la unidad comunitaria...',
    excerpt: 'Festival cultural celebra herencia latina en San Francisco.',
    language: 'Spanish',
    brand: 'El Tecolote',
    category: 'General News',
    date: '2024-01-16',
    author: 'El Tecolote Staff',
  },
  {
    id: 'et-2',
    title: 'Nuevas Iniciativas de Vivienda Asequible en el Distrito',
    content:
      'Organizaciones comunitarias y funcionarios de la ciudad han anunciado nuevas iniciativas para aumentar la vivienda asequible en el Distrito de la Misión, abordando la crisis de desplazamiento...',
    excerpt: 'Programas de vivienda buscan prevenir desplazamiento.',
    language: 'Spanish',
    brand: 'El Tecolote',
    category: 'General News',
    date: '2024-01-15',
    author: 'El Tecolote Staff',
  },
]
export const trendingTopics = [
  'Climate Change',
  'Artificial Intelligence',
  'Olympic Games 2024',
  'Economic Recovery',
  'Space Exploration',
  'Healthcare Innovation',
  'Renewable Energy',
  'Cryptocurrency',
  'Global Politics',
  'Mental Health',
]
export interface RepublishedStory {
  id: string
  storyTitle: string
  republishedAt: string
  user: string
  pageViews: number
}
export const mockRepublishedStories: RepublishedStory[] = [
  {
    id: '1',
    storyTitle: 'Breaking: Major Climate Summit Reaches Historic Agreement',
    republishedAt: '2024-01-16 10:30 AM',
    user: 'John Smith',
    pageViews: 12847,
  },
  {
    id: '2',
    storyTitle: 'Tech Giant Announces Revolutionary AI Breakthrough',
    republishedAt: '2024-01-15 2:45 PM',
    user: 'Sarah Johnson',
    pageViews: 8392,
  },
  {
    id: '3',
    storyTitle: 'Olympic Games: Underdog Team Wins Gold in Dramatic Final',
    republishedAt: '2024-01-14 9:15 AM',
    user: 'Mike Davis',
    pageViews: 15621,
  },
  {
    id: '4',
    storyTitle: 'Economic Recovery: Markets Hit Record Highs',
    republishedAt: '2024-01-13 4:20 PM',
    user: 'Emily Chen',
    pageViews: 6734,
  },
]
export interface AnalyticsData {
  date: string
  views: number
  republished: number
}
export const mockAnalyticsData: AnalyticsData[] = [
  { date: 'Jan 10', views: 4200, republished: 12 },
  { date: 'Jan 11', views: 5800, republished: 18 },
  { date: 'Jan 12', views: 6100, republished: 15 },
  { date: 'Jan 13', views: 7400, republished: 22 },
  { date: 'Jan 14', views: 8900, republished: 28 },
  { date: 'Jan 15', views: 9200, republished: 25 },
  { date: 'Jan 16', views: 10500, republished: 32 },
]

export interface Brand {
  id: string
  name: string
  logo: string
  language: string
  category: string
  region: string
  description: string
  storyCount: number
  feedUrl?: string
  stories?: Story[]
}
export const mockBrands: Brand[] = [
  {
    id: '1',
    name: 'Access Press',
    logo: 'https://accesspress.org/wp-content/uploads/2022/11/cropped-site-icon-192x192.png',
    language: 'English',
    category: 'General News',
    region: 'United States',
    description:
      'Community-focused news covering disability rights and accessibility issues',
    storyCount: 487,
    stories: [
      {
        id: 'ap-1',
        title: 'New Accessibility Standards Proposed for Public Buildings',
        content:
          'Federal officials have announced proposed updates to accessibility standards for public buildings, incorporating feedback from disability advocates and building professionals...',
        excerpt:
          'Proposed standards aim to improve accessibility in public spaces.',
        language: 'English',
        brand: 'Access Press',
        category: 'General News',
        date: '2024-01-16',
        author: 'Access Press Staff',
      },
      {
        id: 'ap-2',
        title: 'Community Programs Expand Services for Disabled Veterans',
        content:
          'Local organizations have expanded their support programs for disabled veterans, offering enhanced accessibility services and community resources...',
        excerpt: 'Enhanced support programs launched for disabled veterans.',
        language: 'English',
        brand: 'Access Press',
        category: 'General News',
        date: '2024-01-15',
        author: 'Access Press Staff',
      },
    ],
  },
  {
    id: '2',
    name: 'Bernardsville News',
    logo: 'https://bloximages.chicago2.vip.townnews.com/newjerseyhills.com/content/tncms/custom/image/152d209a-9495-11e6-b57f-bb192b16232b.png?resize=180%2C180',
    language: 'English',
    category: 'General News',
    region: 'United States',
    description:
      'Local news and community coverage for Bernardsville and surrounding New Jersey areas',
    storyCount: 1234,
    stories: [
      {
        id: 'bn-1',
        title: 'Borough Council Approves New Community Center Plans',
        content:
          'The Bernardsville Borough Council has unanimously approved plans for a new community center, which will include recreational facilities and meeting spaces for local organizations...',
        excerpt: 'New community center project gets green light from council.',
        language: 'English',
        brand: 'Bernardsville News',
        category: 'General News',
        date: '2024-01-16',
        author: 'Bernardsville News Staff',
      },
      {
        id: 'bn-2',
        title: 'Local School District Celebrates Academic Excellence Awards',
        content:
          'Bernardsville schools honored outstanding students and teachers at the annual Academic Excellence Awards ceremony, recognizing achievements in academics, arts, and athletics...',
        excerpt: 'Schools celebrate student and teacher achievements.',
        language: 'English',
        brand: 'Bernardsville News',
        category: 'General News',
        date: '2024-01-15',
        author: 'Bernardsville News Staff',
      },
    ],
  },
  {
    id: '3',
    name: 'City Limits',
    logo: 'https://citylimits.org/wp-content/uploads/2014/10/Favicon-1219.ico',
    language: 'English',
    category: 'Politics',
    region: 'United States',
    description:
      'In-depth coverage of urban policy, housing, and social issues in New York City',
    storyCount: 892,
    stories: [
      {
        id: 'cl-1',
        title: 'Analysis: NYC Housing Crisis Demands Comprehensive Solutions',
        content:
          'As housing affordability reaches critical levels in New York City, policy experts and advocates are calling for comprehensive approaches that address both supply and affordability challenges...',
        excerpt:
          'Experts examine multi-faceted approaches to housing affordability.',
        language: 'English',
        brand: 'City Limits',
        category: 'Politics',
        date: '2024-01-16',
        author: 'City Limits Staff',
      },
      {
        id: 'cl-2',
        title: 'Community Land Trusts Gain Momentum in Brooklyn',
        content:
          'Brooklyn neighborhoods are increasingly turning to community land trusts as a model for preserving affordable housing and preventing displacement...',
        excerpt:
          'Community-led housing models show promise in preserving affordability.',
        language: 'English',
        brand: 'City Limits',
        category: 'Politics',
        date: '2024-01-15',
        author: 'City Limits Staff',
      },
    ],
  },
  {
    id: '4',
    name: 'CivicLex',
    logo: 'https://images.squarespace-cdn.com/content/v1/5ec3e8d457e5067ea0119afb/1597898937433-EDL9N7J8JSXE2AE9N7HC/favicon.ico?format=100w',
    language: 'English',
    category: 'Politics',
    region: 'United States',
    description:
      'Civic engagement and local government coverage for Lexington, Kentucky',
    storyCount: 567,
    stories: [
      {
        id: 'cvl-1',
        title: 'City Council Debates Transportation Infrastructure Plan',
        content:
          'Lexington city council members engaged in extensive debate over a proposed $50 million transportation infrastructure plan aimed at improving public transit and road safety...',
        excerpt: 'Major infrastructure investment under council consideration.',
        language: 'English',
        brand: 'CivicLex',
        category: 'Politics',
        date: '2024-01-16',
        author: 'CivicLex Staff',
      },
      {
        id: 'cvl-2',
        title: 'Community Forums Address Downtown Revitalization Efforts',
        content:
          'Local residents and business owners gathered for community forums to discuss downtown revitalization strategies, including plans for new mixed-use developments and public spaces...',
        excerpt: 'Residents weigh in on downtown development plans.',
        language: 'English',
        brand: 'CivicLex',
        category: 'Politics',
        date: '2024-01-15',
        author: 'CivicLex Staff',
      },
    ],
  },
  {
    id: '5',
    name: 'Columbia Missourian',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a61So2m5LPYcVWLtfjJ5s9/image.png',
    language: 'English',
    category: 'General News',
    region: 'United States',
    description:
      'Community newspaper serving Columbia, Missouri, produced by University of Missouri journalism students',
    storyCount: 1876,
    stories: [
      {
        id: 'cm-1',
        title:
          'University Research Team Makes Breakthrough in Renewable Energy',
        content:
          'Researchers at the University of Missouri have announced a significant breakthrough in solar cell efficiency, potentially revolutionizing renewable energy technology...',
        excerpt: 'MU researchers advance solar energy technology.',
        language: 'English',
        brand: 'Columbia Missourian',
        category: 'General News',
        date: '2024-01-16',
        author: 'Columbia Missourian Staff',
      },
      {
        id: 'cm-2',
        title: 'Local Business District Sees Record Growth in Small Startups',
        content:
          'Columbia business district has experienced a surge in new small business openings, with entrepreneurs citing supportive local policies and community engagement as key factors...',
        excerpt: 'Small business boom transforms downtown Columbia.',
        language: 'English',
        brand: 'Columbia Missourian',
        category: 'General News',
        date: '2024-01-15',
        author: 'Columbia Missourian Staff',
      },
    ],
  },
  {
    id: '6',
    name: 'CommonWealth Beacon',
    logo: 'https://i0.wp.com/commonwealthbeacon.org/wp-content/uploads/2023/08/cropped-Icon_Red-1.png?fit=192%2C192&ssl=1',
    language: 'English',
    category: 'Politics',
    region: 'United States',
    description:
      'Nonprofit news organization covering politics and policy in Massachusetts',
    storyCount: 1432,
    stories: [
      {
        id: 'cb-1',
        title: 'State Legislature Debates Comprehensive Climate Bill',
        content:
          'Massachusetts lawmakers are engaged in heated debate over a comprehensive climate change bill that would set ambitious emissions reduction targets and invest billions in clean energy infrastructure...',
        excerpt: 'Major climate legislation sparks debate at State House.',
        language: 'English',
        brand: 'CommonWealth Beacon',
        category: 'Politics',
        date: '2024-01-16',
        author: 'CommonWealth Beacon Staff',
      },
      {
        id: 'cb-2',
        title: 'Education Reform Package Advances Through Committee',
        content:
          'A comprehensive education reform package has advanced through the Joint Committee on Education, proposing increased funding for public schools and expanded early childhood education programs...',
        excerpt: 'Education funding reforms move forward in legislature.',
        language: 'English',
        brand: 'CommonWealth Beacon',
        category: 'Politics',
        date: '2024-01-15',
        author: 'CommonWealth Beacon Staff',
      },
    ],
  },
  {
    id: '7',
    name: 'Conecta Arizona',
    logo: 'https://conectaarizona.com/wp-content/uploads/2023/09/cropped-Conecta-Arizona-01-1-192x192.png',
    language: 'Spanish',
    category: 'General News',
    region: 'United States',
    description:
      'Spanish-language news and community information serving Arizona',
    storyCount: 743,
    stories: [
      {
        id: 'ca-1',
        title: 'Programa Comunitario Ofrece Recursos de Salud Gratuitos',
        content:
          'Una nueva iniciativa comunitaria en Phoenix está ofreciendo servicios de salud gratuitos y recursos educativos para familias de habla hispana, incluyendo exámenes médicos y asesoramiento nutricional...',
        excerpt: 'Servicios de salud gratuitos disponibles para la comunidad.',
        language: 'Spanish',
        brand: 'Conecta Arizona',
        category: 'General News',
        date: '2024-01-16',
        author: 'Conecta Arizona Staff',
      },
      {
        id: 'ca-2',
        title: 'Escuelas Locales Celebran Éxito en Programas Bilingües',
        content:
          'Los distritos escolares de Arizona están celebrando el éxito de sus programas de educación bilingüe, con estudiantes mostrando mejoras significativas en rendimiento académico y competencia lingüística...',
        excerpt: 'Programas bilingües muestran resultados positivos.',
        language: 'Spanish',
        brand: 'Conecta Arizona',
        category: 'General News',
        date: '2024-01-15',
        author: 'Conecta Arizona Staff',
      },
    ],
  },
  {
    id: '8',
    name: 'D.C. Witness',
    logo: 'https://dcwitness.org/wp-content/themes/dc-witness-child-theme/media/favicons/apple-touch-icon-152x152.png',
    language: 'English',
    category: 'Politics',
    region: 'United States',
    description:
      'Independent news organization covering criminal justice in Washington, D.C.',
    storyCount: 2156,
    stories: [
      {
        id: 'dcw-1',
        title: 'Criminal Justice Reform Initiatives Show Early Promise',
        content:
          'New criminal justice reform programs in Washington, D.C. are showing early signs of success, with reduced recidivism rates and improved community outcomes according to preliminary data...',
        excerpt: 'Reform programs demonstrate positive early results.',
        language: 'English',
        brand: 'D.C. Witness',
        category: 'Politics',
        date: '2024-01-16',
        author: 'D.C. Witness Staff',
      },
      {
        id: 'dcw-2',
        title: 'Community Court Program Expands to Additional Neighborhoods',
        content:
          'The successful community court program is expanding to three additional D.C. neighborhoods, offering alternatives to traditional prosecution for non-violent offenses...',
        excerpt: 'Alternative justice program grows across the district.',
        language: 'English',
        brand: 'D.C. Witness',
        category: 'Politics',
        date: '2024-01-15',
        author: 'D.C. Witness Staff',
      },
    ],
  },
  {
    id: '9',
    name: 'Documented NY',
    logo: 'https://documentedny.com/wp-content/uploads/2020/11/cropped-Documented-NY_Social-Profile-Image-192x192.jpg',
    language: 'English',
    category: 'General News',
    region: 'United States',
    description:
      'News and investigative journalism focused on immigration and New York immigrant communities',
    storyCount: 1089,
    stories: [
      {
        id: 'dny-1',
        title: 'New Immigration Policy Changes Impact NYC Communities',
        content:
          'Recent changes to immigration policies are having significant impacts on New York City immigrant communities, with local organizations working to provide support and resources...',
        excerpt: 'Policy changes affect immigrant community services.',
        language: 'English',
        brand: 'Documented NY',
        category: 'General News',
        date: '2024-01-16',
        author: 'Documented NY Staff',
      },
      {
        id: 'dny-2',
        title: 'Community Organizations Launch Legal Aid Initiative',
        content:
          'A coalition of New York immigrant advocacy groups has launched a new legal aid initiative providing free immigration legal services to underserved communities across the five boroughs...',
        excerpt: 'Free legal services expand for immigrant communities.',
        language: 'English',
        brand: 'Documented NY',
        category: 'General News',
        date: '2024-01-15',
        author: 'Documented NY Staff',
      },
    ],
  },
  {
    id: '10',
    name: 'El Paso Matters',
    logo: 'https://i0.wp.com/elpasomatters.org/wp-content/uploads/2020/01/cropped-epmatters-favicon2.png?fit=192%2C192&ssl=1',
    language: 'English',
    category: 'General News',
    region: 'United States',
    description:
      'Nonprofit newsroom covering El Paso, Texas with in-depth local journalism',
    storyCount: 956,
    stories: [
      {
        id: 'epm-1',
        title: 'Border Community Leaders Discuss Economic Development',
        content:
          'El Paso community leaders gathered to discuss new economic development initiatives aimed at strengthening the border region economy and creating opportunities for local residents...',
        excerpt: 'Leaders plan economic growth strategies for border region.',
        language: 'English',
        brand: 'El Paso Matters',
        category: 'General News',
        date: '2024-01-16',
        author: 'El Paso Matters Staff',
      },
      {
        id: 'epm-2',
        title: 'Water Conservation Efforts Show Positive Results',
        content:
          'El Paso water conservation programs have achieved significant success, with residents reducing water consumption by 15% through innovative conservation strategies and community engagement...',
        excerpt: 'Community conservation efforts yield measurable results.',
        language: 'English',
        brand: 'El Paso Matters',
        category: 'General News',
        date: '2024-01-15',
        author: 'El Paso Matters Staff',
      },
    ],
  },
  {
    id: '11',
    name: 'East Greenwich News',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fJyo91E93tTUfmhGQmmKp1/EG_News_logo.png',
    language: 'English',
    category: 'General News',
    region: 'United States',
    description:
      'Local news and community coverage for East Greenwich, Rhode Island',
    storyCount: 678,
    stories: [
      {
        id: 'egn-1',
        title: 'Historic Main Street Renovation Project Nears Completion',
        content:
          'The multi-year Main Street renovation project is approaching completion, with new sidewalks, lighting, and landscaping transforming the historic downtown area while preserving its character...',
        excerpt: 'Downtown revitalization project reaches final phase.',
        language: 'English',
        brand: 'East Greenwich News',
        category: 'General News',
        date: '2024-01-16',
        author: 'East Greenwich News Staff',
      },
      {
        id: 'egn-2',
        title: 'Local Library Expands Digital Resources and Programs',
        content:
          'The East Greenwich Free Library has launched an expanded collection of digital resources and new community programs, including technology training classes and virtual author events...',
        excerpt: 'Library enhances digital offerings for community.',
        language: 'English',
        brand: 'East Greenwich News',
        category: 'General News',
        date: '2024-01-15',
        author: 'East Greenwich News Staff',
      },
    ],
  },
  {
    id: '12',
    name: 'El Tecolote',
    logo: 'https://i0.wp.com/eltecolote.org/content/wp-content/uploads/2019/11/cropped-Teco_T_red.png?fit=192%2C192&quality=80&ssl=1',
    language: 'Spanish',
    category: 'General News',
    region: 'United States',
    description:
      'Bilingual community newspaper serving San Francisco Mission District',
    storyCount: 1523,
    stories: [
      {
        id: 'et-1',
        title: 'Comunidad de la Misión Celebra Festival Cultural Anual',
        content:
          'La comunidad del Distrito de la Misión se reunió para celebrar su festival cultural anual, destacando la rica herencia latina de San Francisco y promoviendo la unidad comunitaria...',
        excerpt: 'Festival cultural celebra herencia latina en San Francisco.',
        language: 'Spanish',
        brand: 'El Tecolote',
        category: 'General News',
        date: '2024-01-16',
        author: 'El Tecolote Staff',
      },
      {
        id: 'et-2',
        title: 'Nuevas Iniciativas de Vivienda Asequible en el Distrito',
        content:
          'Organizaciones comunitarias y funcionarios de la ciudad han anunciado nuevas iniciativas para aumentar la vivienda asequible en el Distrito de la Misión, abordando la crisis de desplazamiento...',
        excerpt: 'Programas de vivienda buscan prevenir desplazamiento.',
        language: 'Spanish',
        brand: 'El Tecolote',
        category: 'General News',
        date: '2024-01-15',
        author: 'El Tecolote Staff',
      },
    ],
  },
]
